/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_OctoberInputs */

const es_months_october = /** @type {(inputs: Months_OctoberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Octubre`)
};

const en_months_october = /** @type {(inputs: Months_OctoberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`October`)
};

/**
* | output |
* | --- |
* | "October" |
*
* @param {Months_OctoberInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_october = /** @type {((inputs?: Months_OctoberInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_OctoberInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_october(inputs)
	return en_months_october(inputs)
});
export { months_october as "months.october" }